<template>
    <div class="footer">技术支持：查策网</div>
</template>

<script>
    export default {
        name: "Footer"
    }
</script>

<style scoped lang="less">
.footer{text-align: center;color: #B6B6B5;font-size: 13px;margin-top: 10px;}
</style>



// WEBPACK FOOTER //
// src/components/footer/Footer.vue